<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Dettaglio domanda #' + this.$route.params.id : 'Nuova domanda')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">
                        <b-row class="my-1">
                            <b-col sm="3"><label for="domanda">Domanda:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea v-model="domanda.domanda" id="domanda" rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flagsta">Domanda attiva:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="domanda.flagsta" :options="options_attiva" id="flagsta">

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="categoria">Tipo domanda:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="domanda.id_tipodomanda" :options="options_tipo" id="tipo">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="0" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="ordinamento">Ordinamento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="domanda.ordinamento" id="ordinamento" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="domanda.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="domanda.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>                                
                        <b-row class="my-1" v-if="domanda.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="domanda.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>    
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="domanda.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                    
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            
            namespace: NAMESPACE,
            domanda: {
                id: this.$route.params.id || null,
                id_questionariodomande: this.$route.params.id_questionariodomande || null,
                id_tipodomanda: '0',
                domanda: '',
                flagsta: 'S',
                ordinamento: '0',
                datains: null,
                uteins: ''
            },      
            options_attiva: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],      
            options_tipo: [],        
            error: '',
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,                 
        };
    },
    methods: {                
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },

        insert() {

            if (this.domanda.id_tipodomanda == '0') {
                this.showerror = true;
                this.error = "Tipo domanda non selezionato!";               
            } else if (this.domanda.domanda == '') {
                this.showerror = true;
                this.error = "Compilare il campo 'Domanda'!";
            } else {
                
                var json = JSON.stringify(this.domanda);

                var appdettaglio = this;

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/domandadettaglio', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.domanda = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/domandadettaglio/' + this.domanda.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

        }
    },
    created: function () {   
        
        if(!ctrlVismenu("E")){
            this.$router.replace('/accessdenied');
            return;
        }     

        

        var id = this.domanda.id; //se è la prima volta si prova a prendere da getid 
        var token = localStorage.getItem('token');

        if (id != null) {
            
            var appdettaglio = this;

            this.axios.get(NAMESPACE + 'rest/domandedettaglio/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                appdettaglio.domanda = res[0];
                                appdettaglio.showdettaglio = true;


                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }

        //chiamo il servizio che mi restituisce tutti i tipi di domanda
        this.axios.get(NAMESPACE + 'rest/tipodomanda', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        var res = response.data.message;
                        if (res.length > 0) {

                            var options = [];
                            for (var i = 0; i < res.length; i++) {
                                options.push({
                                    value: res[i].id,
                                    text: res[i].tipologia
                                });
                            }

                            this.options_tipo = options;

                        } else {
                            throw new Error("Errore tipi domanda non trovati!");
                        }


                    } else {
                        throw new Error(response.data.message);
                    }


                } catch (e) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                appdettaglio.showerror = true;
                appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    },
    mounted: function() { 
        
    }

}
</script>
